import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { Account, CardStatus } from '@zeusm/personal/core/entities';

import { CardsApi } from './cards-api.interface';
import {
  CardCloseReason,
  CardProduct,
  CardProductsRes,
  CreateCardReq,
  CreateCardRes,
  GetSecureCardDetailsRes,
  ReissueCardReq,
  ReissueCardRes,
} from '../entities/cards';
import {
  cardProductsMock,
  getCardWithStatusMock,
  getCreatedCardAccountMock,
  getReissuedCardAccountMock,
  secureCardDetailsMock,
} from '../mocks/cards-mock';

@Injectable()
export class CardsApiMockService implements CardsApi {
  getProducts(): Observable<CardProductsRes> {
    return of(cardProductsMock).pipe(delay(500));
  }

  create(_params: CreateCardReq): Observable<CreateCardRes> {
    return of(getCreatedCardAccountMock()).pipe(delay(500));
  }

  getSecureCardDetails(_id: string): Observable<GetSecureCardDetailsRes> {
    return of(secureCardDetailsMock).pipe(delay(500));
  }

  getProduct(_id: string): Observable<CardProduct> {
    return of(cardProductsMock.cardProducts[0]).pipe(delay(500));
  }

  reissueCard(_params: ReissueCardReq): Observable<ReissueCardRes> {
    return of(getReissuedCardAccountMock()).pipe(delay(500));
  }

  blockCard(id: string): Observable<Account> {
    return this.#updateStatus(id, CardStatus.Blocked);
  }

  unblockCard(id: string): Observable<Account> {
    return this.#updateStatus(id, CardStatus.Active);
  }

  closeCard(id: string, reason?: CardCloseReason, otherReason?: string, targetAccountID?: string): Observable<Account> {
    void reason;
    void otherReason;
    void targetAccountID;

    return this.#updateStatus(id, CardStatus.Closed);
  }

  #updateStatus(id: string, status: CardStatus): Observable<Account> {
    return of(getCardWithStatusMock(id, status)).pipe(delay(500));
  }
}
